import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/918894915859?text=Hi%20Ghumo%20Ji%20Travels%2C%20I%20want%20to%20book%20a%20taxi%2Ftour%20package."
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      title="Book via WhatsApp"
    >
      <MessageCircle size={28} className="text-white fill-white" />
    </a>
  );
}